import * as zopim from './zopim'

export default zopim



// WEBPACK FOOTER //
// ./src/services/customerSupport/index.js